export const MESSAGE_TYPE = {
  USER: "USER",
  BOT: "BOT"
}
